import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '@environment';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  constructor(private http: HttpClient) {}

  error(message: any, user: any = 'anonymous') {
    return this.http.post<void>(environment.endpoints.logError, user + ' | ' + message.toString() + message.stack);
  }
}
